<script>
import * as glMatrix from 'gl-matrix';
import { onMount } from 'svelte';
const mat4 = glMatrix.mat4;
const vec3 = glMatrix.vec3;
const quat = glMatrix.quat;

let down = false;

let mostRecentXDiff;
let mostRecentYDiff;

onMount(() => {

  const canvas = document.querySelector("#glCanvas")
  const gl = canvas.getContext("webgl", {preserveDrawingBuffer:true,
    stencil:true});
  if (gl == null) {
    alert("Unable to initialize WebGL.");
    return;
  }

  gl.clearColor(1.0, 0.0, 1.0, 1.0);
  gl.clear(gl.COLOR_BUFFER_BIT);

  const vsSource = `
    precision highp float;

    // the one we are rendering 
    attribute vec4 aVertexPosition;

    uniform vec3 uNormalDirection;
    uniform float uNormalOffset;

    uniform mat4 uModelViewMatrix;
    uniform mat4 uProjectionMatrix;
    uniform bool uDistort;
    
    uniform bool uPreReflect;
    uniform vec3 uReflectNormalDirection;
    uniform float uReflectNormalOffset;

    varying vec4 vPos;

    void main() {
      
      vec4 maybeReflectPos;
      if (uPreReflect) {
        float diff = 
           aVertexPosition[0] * uReflectNormalDirection[0] +
           aVertexPosition[1] * uReflectNormalDirection[1] +
           aVertexPosition[2] * uReflectNormalDirection[2]
           - uReflectNormalOffset;
        maybeReflectPos = vec4(aVertexPosition[0] + (-2.0 * diff) * uReflectNormalDirection[0],
        aVertexPosition[1] + (-2.0 * diff) * uReflectNormalDirection[1],
        aVertexPosition[2] + (-2.0 * diff) * uReflectNormalDirection[2],
        1);

      } else {
        maybeReflectPos = vec4(aVertexPosition[0], aVertexPosition[1],
        aVertexPosition[2], 1);
      }

      if (uDistort) {
        float diff = 
           maybeReflectPos[0] * uNormalDirection[0] +
           maybeReflectPos[1] * uNormalDirection[1] +
           maybeReflectPos[2] * uNormalDirection[2]
           - uNormalOffset;
        if (diff > 0.0) {
          diff = 0.0;
        }
        gl_Position = uProjectionMatrix * uModelViewMatrix * 
          vec4(maybeReflectPos[0] + (-0.40 * diff) * uNormalDirection[0],
               maybeReflectPos[1] + (-0.40 * diff) * uNormalDirection[1],
               maybeReflectPos[2] + (-0.40 * diff) * uNormalDirection[2],
               1);
        // gl_Position = uProjectionMatrix * uModelViewMatrix * 
        //   vec4(maybeReflectPos[0] * 0.5,
        //        maybeReflectPos[1] * 0.5,
        //        maybeReflectPos[2] * 0.5,
        //        1);
      } else {
        gl_Position = uProjectionMatrix * uModelViewMatrix * maybeReflectPos;
      }
      vPos = aVertexPosition;
    }
  `

  const fsSource = `
    precision highp float;
    uniform float uAlpha;

    varying vec4 vPos;
    void main() {
      gl_FragColor = vec4((vPos[0] + 1.0) * 0.5, (vPos[1] + 1.0) * 0.5, (vPos[2] + 1.0) * 0.5, uAlpha);
    }
  `

  const shaderProgram = initShaderProgram(gl, vsSource, fsSource);
    

  const programInfo = {
    program: shaderProgram,
    attribLocations: {
      vertexPosition: gl.getAttribLocation(shaderProgram, 'aVertexPosition'),
    },
    uniformLocations: {
      projectionMatrix: gl.getUniformLocation(shaderProgram, 'uProjectionMatrix'),
      modelViewMatrix: gl.getUniformLocation(shaderProgram, 'uModelViewMatrix'),
      distort: gl.getUniformLocation(shaderProgram, 'uDistort'),
      normalDirection: gl.getUniformLocation(shaderProgram, 'uNormalDirection'),
      normalOffset: gl.getUniformLocation(shaderProgram, 'uNormalOffset'),
      prereflect: gl.getUniformLocation(shaderProgram, 'uPreReflect'),
      reflectNormalDirection: gl.getUniformLocation(shaderProgram, 'uReflectNormalDirection'),
      reflectNormalOffset: gl.getUniformLocation(shaderProgram, 'uReflectNormalOffset'),
      alpha: gl.getUniformLocation(shaderProgram, 'uAlpha')
    }
  }

  const buffers = initBuffers(gl);
  // console.log("drawing scene");

  drawScene(gl, programInfo,buffers);
});

function drawScene(gl, programInfo, buffers) {
  gl.clearColor(0.2, 0.2, 0.2, 1.0);
  gl.clearDepth(1.0);
  gl.enable(gl.DEPTH_TEST);
  gl.depthFunc(gl.LEQUAL);

  gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);

  const fieldOfView = 45 * Math.PI / 180;
  const aspect = gl.canvas.clientWidth / gl.canvas.clientHeight;
  const zNear = 0.1;
  const zFar = 100.0;
  
  const projectionMatrix = mat4.create();
  mat4.perspective(projectionMatrix, fieldOfView, aspect, zNear, zFar);
  // mat4.translate(projectionMatrix, projectionMatrix, [0.0, 4.0, 0.0])
  // mat4.targetTo(projectionMatrix, [1.0, 1.0, 1.0], [0.0, 0.0, -6.0],  [0.0, 0.0, 1.0])
  // mat4.rotateX(projectionMatrix, projectionMatrix, -40 * Math.PI / 180);

  const modelViewMatrix = mat4.create();
  mat4.translate(modelViewMatrix, modelViewMatrix, [0.0, 0.0, -6.0]);
  // mat4.rotateX(modelViewMatrix, modelViewMatrix, -40 * Math.PI / 180);

  // mat4.targetTo(modelViewMatrix, [0.0, 0.0, 6.0], [0.0, 0.0, 0.0], [0.0, 0.0, 1.0])

  {
    const numComponents = 3;
    const type = gl.FLOAT;
    const normalize = false;
    const stride = 0;
    const offset = 0;

    gl.bindBuffer(gl.ARRAY_BUFFER, buffers.position);
    gl.vertexAttribPointer(programInfo.attribLocations.vertexPosition, numComponents, type, normalize, stride, offset);
    gl.enableVertexAttribArray(programInfo.attribLocations.vertexPosition);
  }

  gl.useProgram(programInfo.program);

  gl.uniformMatrix4fv(programInfo.uniformLocations.projectionMatrix,
    false,
    projectionMatrix);
  gl.uniformMatrix4fv(programInfo.uniformLocations.modelViewMatrix,
    false,
    modelViewMatrix);
  // console.log(projectionMatrix);

  // {
  //   const offset = 0;
  //   const vertexCount = 6;
  //   gl.drawArrays(gl.TRIANGLES, offset, vertexCount);
  // }

  gl.uniform1f(programInfo.uniformLocations.alpha, 1.0);

  const getNormalOffset = function(i) {
    if (i == 0) {
      return 1.0;
    } else if (i == 1) {
      return 1.0;
    } else if (i == 2){
      return -0.577;
    } else {
      return 1.0;
    }
  }

  const getNormalDirection = function(i) {
    if (i == 0) {
      return vec3.fromValues(0.0, 0.0, 1.0);
    } else if (i == 1) {
      return vec3.fromValues(-1.0, 0.0, 0.0);
    } else if (i == 2){
      return vec3.fromValues(0.577, -0.577, -0.577);
    } else {
      return vec3.fromValues(0.0, 1.0, 0.0);
    }
  }
  const setNormalDirection = function(i, loc) {
    var dir = getNormalDirection(i);
    gl.uniform3f(loc, dir[0], dir[1], dir[2]);
    // if (i == 0) {
    //   gl.uniform3f(loc, 0.0, 0.0, 1.0);
    // } else if (i == 1) {
    //   gl.uniform3f(loc, -1.0, 0.0, 0.0);
    // } else if (i == 2){
    //   gl.uniform3f(loc, 0.577, -0.577, -0.577);
    // } else {
    //   gl.uniform3f(loc, 0.0, 1.0, 0.0);
    // }
  }

  const draw = function() {
    gl.uniformMatrix4fv(programInfo.uniformLocations.modelViewMatrix,
      false,
      modelViewMatrix);

    gl.clearColor(0.22, 0.22, 0.94, 1.0);
    gl.clearDepth(1.0);
    gl.enable(gl.DEPTH_TEST);
    gl.depthFunc(gl.LEQUAL);
    gl.enable(gl.STENCIL_TEST);
    gl.enable(gl.BLEND)
    gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT | gl.STENCIL_BUFFER_BIT);
    
    const n_faces = 4;


    gl.uniform1i(programInfo.uniformLocations.distort, false);
    gl.useProgram(programInfo.program);
    gl.uniform1f(programInfo.uniformLocations.normalOffset, 1.0);
    gl.uniform3f(programInfo.uniformLocations.normalDirection, -1.0, 0.0, 0.0);

    // meaning of bits from lowest to highest
    // bits 0 - 2: First-order geometry assignment:
    //     0 -> nothing
    //     1 -> external geometry
    //     2 -> glass face 0 
    //     3 -> glass face 1
    //     etc.
    // 
    console.assert(n_faces < 6);

    // Render real surfaces
    for (var i = 0; i < n_faces; i++) {
      const key = i + 2;
      // gl.clearStencil();
      gl.stencilFunc(gl.ALWAYS, key, 0xFF);
      gl.depthFunc(gl.LEQUAL);
      gl.stencilOp(gl.KEEP, gl.KEEP, gl.REPLACE);
      // gl.depthMask(false);
      // gl.colorMask(false, false, false, false);
      let offset = i * 3;
      let vertexCount = 3;
      gl.drawArrays(gl.TRIANGLES, offset, vertexCount);
    }
    
    // stencils:
    // 1 -> external geometry

    // // Render real external geometry. Respect depth but
    // stencil it out to make sure refractions don't write over it.
    gl.stencilOp(gl.KEEP, gl.KEEP, gl.REPLACE);
    gl.stencilFunc(gl.ALWAYS, 1, 0xFF);
    // TODO: stop naming random things "offset"
    let offset = n_faces * 3;
    let vertexCount = 3;
    gl.drawArrays(gl.TRIANGLES, offset, vertexCount);


    // Render refracted geometry
    gl.uniform1i(programInfo.uniformLocations.distort, true);
    for (var i = 0; i < n_faces; i++) {
      // if (i != 3) {
      //   continue;
      // }
      
      gl.useProgram(programInfo.program);
      gl.uniform1f(programInfo.uniformLocations.normalOffset, getNormalOffset(i));
      setNormalDirection(i, programInfo.uniformLocations.normalDirection);

      // // gl.clearStencil();
      // gl.stencilFunc(gl.ALWAYS, key, 0xFF);
      gl.depthFunc(gl.GEQUAL);
      // gl.stencilOp(gl.KEEP, gl.KEEP, gl.REPLACE);
      // // gl.depthMask(false);
      // // gl.colorMask(false, false, false, false);
      // let offset = 0;
      // let vertexCount = 3;
      // gl.drawArrays(gl.TRIANGLES, offset, vertexCount);

      // Rendering transparent objects, so reverse depth test

      // Rely on stencils to stay within entry surface.
      
      // Reversed depth function only works because shape is convex.
      gl.depthFunc(gl.GEQUAL);
      for (var j = 0; j < n_faces; j++) {
        if (j == i) {
          continue;
        }

        // bits 3-5:
        // 0 -> nothing refracted
        // 1 -> face 0
        // 2 -> face 1
        // etc.

        const key = (i + 2) + ((j + 1) * 8)

        // Ok to draw into current face, but still test depth.
        gl.stencilFunc(gl.EQUAL, key, 0x7);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.REPLACE);
        offset = 3 * j;
        vertexCount = 3;
        gl.drawArrays(gl.TRIANGLES, offset, vertexCount);
        
        // gl.clear(gl.DEPTH_BUFFER_BIT);
        // gl.stencilFunc(gl.EQUAL, key + 1, 0xFF);
        // gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);

        // offset = n_faces * 3;
        // vertexCount = 3;
        // gl.drawArrays(gl.TRIANGLES, offset, vertexCount);
      }

      // continue;
      // Rely on stencils again to stay within entry surface.
      // clear depth.

      // gl.clear(gl.DEPTH_BUFFER_BIT);

      gl.depthFunc(gl.GEQUAL);
      for (var j = 0; j < n_faces; j++) {
        if (j == i) {
          continue;
        }
        
        const key = (i + 2) + ((j + 1) * 8)
        
        let refract = true;

        // var translation = vec3.create();
        // mat4.getTranslation(translation, modelViewMatrix);
        // vec3.normalize(translation, translation);
        // console.log(translation);

        var rot = quat.create();
        mat4.getRotation(rot, modelViewMatrix);
        // console.log(rot);

         // console.log(modelViewMatrix);
        var normal = getNormalDirection(j);
        // Dot product between z row and normal of internal surface 
        var dotProd = modelViewMatrix[2] * normal[0] +
          modelViewMatrix[6] * normal[1] +
          modelViewMatrix[10] * normal[2];
        var absDotProd = Math.abs(dotProd);
        // refract = absDotProd > 0.3;


        // Draw external geometry as seen through the refracted internal surfaces
        gl.stencilFunc(gl.EQUAL, key, 0xFF);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);

        offset = n_faces * 3;
        vertexCount = 3;
        gl.drawArrays(gl.TRIANGLES, offset, vertexCount);

        // Draw internal geometry as reflected through the refracted internal surfaces
        for (var k = 0; k < n_faces; k++) {
          if (k == j) {
            continue;
          }
          gl.uniform1i(programInfo.uniformLocations.prereflect, true);
          
          var opacity = (1.0 - absDotProd) * (1.0 - absDotProd);
          gl.uniform1f(programInfo.uniformLocations.alpha, opacity);


          gl.stencilFunc(gl.EQUAL, key, 0xFF);
          gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
          gl.uniform1f(programInfo.uniformLocations.reflectNormalOffset, getNormalOffset(j));
          setNormalDirection(j, programInfo.uniformLocations.reflectNormalDirection);

          offset = k * 3;
          vertexCount = 3;
          gl.drawArrays(gl.TRIANGLES, offset, vertexCount);
          gl.uniform1f(programInfo.uniformLocations.alpha, 1.0);

          gl.uniform1i(programInfo.uniformLocations.prereflect, false);
        }
      }
    }



  }
  // document.getElementById("move").onclick = () => {
  //   adjustPosition(0, 5);

  //   draw();
  // }
  // document.getElementById("move2").onclick = () => {
  //   adjustPosition(5, 0);
  //   draw();
  // }

  const canvas = document.getElementById("glCanvas")
  let x_init = 0;
  let y_init = 0;
  canvas.onmousedown = (e) => {
    // event.dataTransfer.setDragImage(canvas, -99999, -99999);
    // console.log("onmousedown");
    x_init = e.offsetX;
    y_init = e.offsetY;
    down = true;
  }

  canvas.ontouchstart = (e) => {
    // event.dataTransfer.setDragImage(canvas, -99999, -99999);
    // console.log("onmousedown");
    x_init = e.touches[0].clientX;
    y_init = e.touches[0].clientY;
    down = true;
  }

  canvas.onmouseup = canvas.ontouchend = canvas.ontouchcancel = (e) => {
    // event.dataTransfer.setDragImage(canvas, -99999, -99999);
    // console.log("onmouseup");
    down = false;
  }
  canvas.onmousemove = (e) => {
    if (down) {
      adjustPosition(e.offsetX - x_init, e.offsetY - y_init);

      x_init = e.offsetX;
      y_init = e.offsetY;
      draw();
    }
  }

  canvas.ontouchmove = (e) => {
  	if (down) {
  	  e.preventDefault();
      adjustPosition(e.changedTouches[0].clientX - x_init, e.changedTouches[0].clientY - y_init);

      x_init = e.changedTouches[0].clientX;
      y_init = e.changedTouches[0].clientY;
      draw();
    }
  }

  const adjustPosition = (x_diff, y_diff) => {
  	mostRecentXDiff = x_diff;
  	mostRecentYDiff = y_diff;
    // It seems that mat4 indexes in column-major order.
    //
    // mat4 indexing:
    // 0 4  8 12
    // 1 5  9 13
    // 2 6 10 14
    // 3 7 11 15
    //
    // r r r t
    // r r r t
    // r r r t
    // . . . 1
    //
    // Observationally, rotateX rotates row-by-row, which is kind of like
    // rotating the inverse, which is not what we want...
    //
    // It just rotates the rows one by one

    // What we actually want to do is to just rotate column-by-column,
    // an easy way is to transpose it before / after.
    // But then we need to make sure we don't mess up the translation to we save it before
    // and copy it back after.
    let translation = vec3.create();
    mat4.getTranslation(translation, modelViewMatrix);
    mat4.transpose(modelViewMatrix, modelViewMatrix);
    mat4.rotateY(modelViewMatrix, modelViewMatrix, -1.0 * x_diff * Math.PI / 180);
    mat4.rotateX(modelViewMatrix, modelViewMatrix, -1.0 * y_diff * Math.PI / 180);
    mat4.transpose(modelViewMatrix, modelViewMatrix);
    modelViewMatrix[12] = translation[0];
    modelViewMatrix[13] = translation[1];
    modelViewMatrix[14] = translation[2];
  }

  adjustPosition(220, 190);
  draw();

}

function initBuffers(gl) {
  const positionBuffer = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);

  const positions = [
       -1.0, 1.0, 1.0,
       1.0, 1.0, 1.0,
       -1.0, -1.0, 1.0,

       -1.0, -1.0, 1.0,
       -1.0, 1.0, 1.0,
       -1.0, 1.0, -1.0,

       -1.0, -1.0, 1.0,
       1.0, 1.0, 1.0,
       -1.0, 1.0, -1.0,

       -1.0, 1.0, 1.0,
       1.0, 1.0, 1.0,
       -1.0, 1.0, -1.0,

       -1.0, 1.0, -1.5,
       1.0, 1.0, -1.5,
       -1.0, -1.0, -1.5,
  ]

  gl.bufferData(gl.ARRAY_BUFFER,
    new Float32Array(positions),
    gl.STATIC_DRAW);
  return {
    position: positionBuffer,
  };
}


function loadShader(gl, type, source) {
  const shader = gl.createShader(type);
  gl.shaderSource(shader, source);
  gl.compileShader(shader);
  if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
    alert('An error occured compiling the shaders: ' + gl.getShaderInfoLog(shader));
    gl.deleteShader(shader);
    return null;
  }
  return shader;
}

// Equivalent of linking
function initShaderProgram(gl, vsSource, fsSource) {
  const vertexShader = loadShader(gl, gl.VERTEX_SHADER, vsSource);
  const fragmentShader = loadShader(gl, gl.FRAGMENT_SHADER, fsSource);

  const shaderProgram = gl.createProgram();
  gl.attachShader(shaderProgram, vertexShader);
  gl.attachShader(shaderProgram, fragmentShader);
  gl.linkProgram(shaderProgram);

  if (!gl.getProgramParameter(shaderProgram, gl.LINK_STATUS)) {
    alert('Unable to initialize the shader program: ' + gl.getProgramInfoLog(shaderProgram));
    return null;
  }
  return shaderProgram;
}

// window.onload = main;
</script>

<main>
	<canvas id="glCanvas" width=500 height=500></canvas>
	<br>
	<!-- <button id="move">rotX</button>
	<button id="move2">rotY</button>
	down is {down}
	<br>
	mostRecentXDiff is {mostRecentXDiff}
	<br>
	mostRecentXDiff is {mostRecentYDiff} -->
</main>

<style>
button {
font-size: 5vw;
}

canvas {
	border: solid 1px white;
	width: 100%;
	border-radius: 12px;
}

canvas:hover {
	cursor: grab;
}

canvas:active {
	cursor: grabbing;
}

</style>